let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iixBf")).then(() => parcelRequire('jC3Vf'));